/**
 * Stato di una installazione, calcolato in base allo stato delle singole macchine
 */
export enum InstallationPredictedStatusEnum {
    Ok = 0,
    Failure = 1,
    Warning = 2,
}

export function installationPredictedStatusEnumLabel(status: InstallationPredictedStatusEnum): string {
    switch (status) {
        case InstallationPredictedStatusEnum.Ok:
            return "enum.installation_predicted_status.ok";
        case InstallationPredictedStatusEnum.Failure:
            return "enum.installation_predicted_status.failure";
        case InstallationPredictedStatusEnum.Warning:
            return "enum.installation_predicted_status.warning";
        default:
            return "enum.installation_predicted_status.ok";
    }
}
